import { notification } from "antd";

import { invokeApi } from "./authHelper";

export async function get_app_templates() {
  return await invokeApi({
    path: "/rest/portal/templates",
    method: "GET",
    onError: e => handleError(e, "Error Loading Page Templates"),
  });
}

export async function get_app_custom() {
  return await invokeApi({
    path: "/rest/portal/custom",
    method: "GET",
    onError: e => handleError(e, "Error Loading App Configuration"),
  });
}

export async function get_app_features() {
  return await invokeApi({
    path: "/rest/portal/features",
    method: "GET",
    onError: e => handleError(e, "Error Loading App Features"),
  });
}

function handleError(e, msg = null) {
  notification.error({
    message: (msg !== null ? msg + ": " : "") + (e?.data?.message ?? e?.message ?? "unknown"),
    duration: 5,
  });
}
